import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import DocumentDownload from "../../Entity/DocumentDownload";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";

const eventDispatcher = getEventDispatcher();

const PauseDownloadListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);

    try {
        await eventDispatcher.dispatch('PauseDownloadManager');
    } catch (error) {
    }

    await eventDispatcher.dispatch('PauseDownloadAction');
    await eventDispatcher.dispatch('ChangeDocumentStatusToPaused', document);
}

export default PauseDownloadListener;